import { getValidationTexts } from '../../../../../constants/form';
import { useTranslation } from '../../../../../translations';
import { FOR_ID, FOR_NAME } from '../../constants/modalTypes';
import { useRequestsHandlerData } from '../../../../../hooks/useRequestsHandlerData';
import { useEffect } from 'react';

export default function useHandleFormErrors({ wishType, addNewError, input, badWords, defaultValue }) {
  const { t } = useTranslation();

  const onRejected = () => {
    ({
      [FOR_ID]() {
        addNewError({ id: { message: getValidationTexts(t).INVALID_ID } });
      },
      [FOR_NAME]() {
        if (badWords?.includes(defaultValue)) addNewError({ name: { message: t(input?.badWordText) } });
      },
    })[wishType]?.();
  };

  useEffect(() => {
    if (!defaultValue) return;
    onRejected();
  }, []);

  return useRequestsHandlerData(
    ['requestsUserGetFriend', 'requestsUserGetWishUserData', 'requestsUserGetUserData'].map((address) => ({
      address,
      rejected: onRejected,
    })),
  );
}
